import {Action} from '@ngrx/store';
import {IButtonSettingsState} from '../state/button-settings.state';

export enum BUTTON_SETTINGS_ACTION {
  INIT_BUTTON_SETTINGS = 'INIT_BUTTON_SETTINGS',
  RESET_BUTTON_SETTINGS = 'RESET_BUTTON_SETTINGS',
}

export class SetButtonSettings implements Action {
  readonly type = BUTTON_SETTINGS_ACTION.INIT_BUTTON_SETTINGS;

  constructor(public payload: IButtonSettingsState) {}
}

// eslint-disable-next-line max-classes-per-file
export class ResetButtonSettings implements Action {
  readonly type = BUTTON_SETTINGS_ACTION.RESET_BUTTON_SETTINGS;
}

export type ButtonSettingsAction = SetButtonSettings | ResetButtonSettings;
